import type { ToolCall } from './types';

// Numbers in the answer that no tool output accounts for (models round, convert or invent).
// Integers below 10 are ignored.
export function unverifiedNumbers(text: string, calls: ToolCall[]): number[] {
  const pool = new Set<number>();
  for (const c of calls) collect(c.output, pool);
  const out: number[] = [];
  for (const m of text.matchAll(/-?\d+(?:[.,]\d+)?/g)) {
    const raw = m[0]!.replace(',', '.');
    const n = Number(raw);
    if (!Number.isFinite(n)) continue;
    const decimals = raw.includes('.') ? raw.split('.')[1]!.length : 0;
    if (decimals === 0 && Math.abs(n) < 10) continue;
    if (!accounted(n, decimals, pool)) out.push(n);
  }
  return out;
}

function accounted(n: number, decimals: number, pool: Set<number>): boolean {
  const tol = decimals === 0 ? 0.5 : 0.5 * 10 ** -decimals;
  for (const v of pool) {
    if (Math.abs(v - n) <= tol + 1e-9) return true;
  }
  return false;
}

function collect(v: unknown, into: Set<number>, depth = 0): void {
  if (depth > 6) return;
  if (typeof v === 'number' && Number.isFinite(v)) {
    into.add(v);
    return;
  }
  if (typeof v === 'string') {
    const n = Number(v);
    if (v.trim() !== '' && Number.isFinite(n)) into.add(n);
    return;
  }
  // an exported model is megabytes of bytes; only its size is a number an answer may quote
  if (ArrayBuffer.isView(v)) {
    into.add(v.byteLength);
    return;
  }
  if (Array.isArray(v)) {
    into.add(v.length);
    for (const x of v) collect(x, into, depth + 1);
    return;
  }
  if (v && typeof v === 'object') for (const x of Object.values(v)) collect(x, into, depth + 1);
}
